import { InjectionToken } from '@angular/core';
import { environment } from '@env';

type Environment = typeof environment;

export const ENV_CONFIG = new InjectionToken<Environment>('ENV_CONFIG', {
  providedIn: 'root',
  factory: () => environment,
});
